import React from "react";
import {StoryblokComponent} from "@storyblok/react";

export let CardWithBlackNumberContainers = ({blok}) => {
    return <div className={`row row-cols-1 row-cols-md-${blok.NumberOfColumns} align-items-top pe-0`}>
        {blok.Cards.map(c => <div className="d-flex col">
            <StoryblokComponent blok={c}/>
        </div>)}
    </div>
}